import { BarDatum, ResponsiveBar } from "@nivo/bar";
import { senecPrimaryColors, senecSecondaryColors } from "src/styles/ekp-theme/senecEkpTheme";
import { Box, SxProps, Typography } from "@mui/material";

export interface MiniBarChartProps {
    dataSeries: BarDatum[];
    errorMessage?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomBars = ({ bars }: any) => {
    const BAR_WIDTH = 4;

    return (
        <g>
            {bars.map((bar: { x: number; y: number; width: number; height: number; color: string }, index: number) => (
                <g key={index}>
                    <rect
                        x={bar.x + bar.width / 2 - BAR_WIDTH / 2}
                        y={bar.y}
                        width={BAR_WIDTH + 2} // The plus 2 is needed for the clipPath to work!
                        height={bar.height > 0 ? bar.height + 1 : 0} // The plus 1 is needed that the bars are aligned with bottom line
                        fill={bar.color}
                        clipPath={"inset(0 1px 0 0 round 20px 20px 0 0)"}
                    />
                </g>
            ))}
        </g>
    );
};

const CustomGridLine =
    (y: number) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ yScale, innerWidth }: any) => (
        <line
            x1={1}
            x2={innerWidth - 1}
            y1={yScale(y)}
            y2={yScale(y)}
            stroke={senecPrimaryColors.lightWarmGrey}
            strokeWidth={2}
            strokeLinecap={"round"}
        />
    );
export const styledGridLine: SxProps = {
    width: "100%",
    height: "2px",
    backgroundColor: senecPrimaryColors.lightWarmGrey,
    borderRadius: "20px",
};

export const MiniBarChart = ({ dataSeries, errorMessage }: MiniBarChartProps) => {
    return (
        <Box height={55} width={"100%"}>
            {!errorMessage && (
                <ResponsiveBar
                    data={dataSeries}
                    keys={["value"]}
                    indexBy="day"
                    margin={{ bottom: 23, top: 1 }}
                    borderRadius={4}
                    isInteractive={false}
                    animate={false}
                    colors={[senecSecondaryColors.limeGreen]}
                    maxValue={100}
                    gridYValues={[]}
                    axisBottom={{
                        renderTick: (tick) => (
                            <text
                                x={tick.x}
                                dominantBaseline="text-before-edge"
                                textAnchor="middle"
                                transform="translate(0,10) rotate(0)"
                                style={{
                                    fontSize: "12px",
                                    fontFamily: "Mark Pro,sans-serif",
                                    fontWeight: tick.tickIndex === dataSeries.length - 1 ? "bold" : "normal",
                                }}
                            >
                                {tick.value}
                            </text>
                        ),
                    }}
                    layers={["grid", "axes", CustomGridLine(50), CustomGridLine(100), CustomGridLine(0), CustomBars]}
                />
            )}
            {errorMessage && (
                <Box>
                    <Box sx={{ ...styledGridLine, marginBottom: "15px" }}></Box>
                    <Box sx={{ ...styledGridLine, marginBottom: "15px" }}></Box>
                    <Box sx={{ ...styledGridLine }}></Box>
                    <Typography
                        variant={"h5"}
                        sx={{
                            color: senecSecondaryColors.neutralGray20,
                            textTransform: "none",
                            fontWeight: 700,
                            overflow: "hidden",
                            textAlign: "right",
                            fontSize: { xs: "12px" },
                            marginTop: "8px",
                        }}
                    >
                        {errorMessage}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};
